import { getCookies, deleteCookie, setCookie } from 'cookies-next';

export async function getUserToken(): Promise<{ isLoggedIn: boolean; token: string }> {
  const cookies = await getCookies();

  if (!cookies) {
    return { isLoggedIn: false, token: '' };
  }

  const sessionCookie = cookies.stk;

  return { isLoggedIn: !!sessionCookie, token: sessionCookie || '' };
}

export function setUserToken(token: string): void {
  setCookie('stk', token, { maxAge: 365 * 24 * 60 * 60, sameSite: 'strict' });
}

export function logout(): void {
  deleteCookie('stk');
}
